import { Grid, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatAmount } from 'src/shared/functions/formatAmount';
import { StatisticsTitleAndValueRow } from './statisticsTitleAndValueRow';
import { MemberGrowthResponse } from '../models/memberGrowthResponse';

type StatisticsMemberGrowthContentProps = {
  growthData: MemberGrowthResponse | undefined;
  isLoading: boolean;
};

export const StatisticsMemberGrowthContent = (props: StatisticsMemberGrowthContentProps) => {
  const { growthData, isLoading } = props;
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <>
        <Skeleton variant='text' sx={{ height: '40px' }} />
        <Skeleton variant='text' sx={{ height: '37px' }} />
        <Skeleton variant='text' sx={{ height: '37px' }} />
        <Skeleton variant='text' sx={{ height: '37px' }} />
        <Skeleton variant='text' sx={{ height: '37px' }} />
        <Skeleton variant='text' sx={{ height: '37px' }} />
        <Skeleton variant='text' sx={{ height: '37px' }} />
        <Skeleton variant='text' sx={{ height: '40px ' }} />
      </>
    );
  }
  return (
    <>
      <Grid item xs={12}>
        <StatisticsTitleAndValueRow
          uppercase
          divider
          title={t('statistics:memberProgress.labels.initBalance')}
          value={`${formatAmount(growthData?.startCount ?? 0)}`}
          endEndornment='st'
          bigValue
        />
      </Grid>
      <Grid item xs={12}>
        <StatisticsTitleAndValueRow
          uppercase
          divider
          title={t('statistics:memberProgress.labels.new')}
          value={`+${formatAmount(growthData?.enterCount ?? 0)}`}
          endEndornment='st'
        />
      </Grid>
      <Grid item xs={12}>
        <StatisticsTitleAndValueRow
          uppercase
          divider
          title={t('statistics:memberProgress.labels.reRegister')}
          value={`+${formatAmount(growthData?.reenterCount ?? 0)}`}
          endEndornment='st'
        />
      </Grid>
      <Grid item xs={12}>
        <StatisticsTitleAndValueRow
          uppercase
          divider
          title={t('statistics:memberProgress.labels.deRegistered')}
          value={`-${formatAmount(growthData?.exitCount ?? 0)}`}
          endEndornment='st'
        />
      </Grid>
      <Grid item xs={12}>
        <StatisticsTitleAndValueRow
          uppercase
          divider
          title={t('statistics:memberProgress.labels.movedIn')}
          value={`${formatAmount(growthData?.movedInCount ?? 0)}`}
          endEndornment='st'
        />
      </Grid>
      <Grid item xs={12}>
        <StatisticsTitleAndValueRow
          uppercase
          divider
          title={t('statistics:memberProgress.labels.movedOut')}
          value={`-${formatAmount(growthData?.movedOutCount ?? 0)}`}
          endEndornment='st'
        />
      </Grid>
      <Grid item xs={12}>
        <StatisticsTitleAndValueRow
          uppercase
          divider
          title={t('statistics:memberProgress.labels.deceased')}
          value={`-${formatAmount(growthData?.deceasedCount ?? 0)}`}
          endEndornment='st'
        />
      </Grid>
      <Grid item xs={12}>
        <StatisticsTitleAndValueRow
          uppercase
          divider
          title={t('statistics:memberProgress.labels.closingBalance')}
          value={`${formatAmount(growthData?.endCount ?? 0)}`}
          endEndornment='st'
          bigValue
        />
      </Grid>
    </>
  );
};
